import React, { lazy, Suspense } from 'react'
import './App.css';
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import { WindowSizeProvider } from './context/windowSizeContext';
import { Loader } from './components' // need loader normally imported as fallback
const Home = lazy(() => import('./components/Home'))
const Page = lazy(() => import('./components/Page'))
const AppNav = lazy(() => import('./components/AppNav'))
const About = lazy(() => import('./components/About'))
const GameBoard = lazy(() => import('./components/GameBoard'))

// hardcoded name value for Ravi Chandra Rachamalla
const portfolioName = 'Ravi Chandra Rachamalla'

// with a context provider set up for the window size (for now)
// lets return our app functuion component below but wrapped in our context provider
function WindowSizeWrapper() {
  return (
    <WindowSizeProvider>
      <App />
    </WindowSizeProvider>
  )
}

function App() {
  return (
    <div className="App">
      {/* Used for React Router Dom */}
      <Router>
        <Suspense fallback={<Loader />}>
          {/* The Navigation - TBD */}
          <AppNav name={portfolioName} />
          {/* Site Navigation Using Switch from React Router Dom */}
          <Switch>
            {/* Path for Home */}
            <Route exact path="/">
              {/* the Jumbotron (Hero) for the site */}
              <Home name={portfolioName} title="Full Stack Mobile Developer" tagline="Forever in the Pursuit of Knowledge" >

              </Home>
            </Route>

            {/* The Route for schools */}
            <Route path="/schools">
              <Page title="Education" datasource="./data/education.json" />
            </Route>

            {/* The Route for jobs */}
            <Route path="/jobs">
              <Page title="Job History" datasource="./data/jobs.json" />
            </Route>

            {/* The Route for skills */}
            <Route path="/skills">
              <Page title="Summary of Qualifications" datasource="./data/skills.json" />
            </Route>

            {/* The Route for projects */}
            <Route path="/projects">
              <Page title="Projects" datasource="./data/projects.json" />
            </Route>

            {/* The Route for about me */}
            <Route path="/about">
              <About />
            </Route>

            {/* The Route for Games */}
            <Route path="/games">
              <GameBoard />
            </Route>

            {/* Path for an undefined route */}
            <Route>
              <Page />
            </Route>

          </Switch>
        </Suspense>
      </Router>
    </div>
  );
}

export default WindowSizeWrapper;
